<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
    <mat-select name="Country" [(ngModel)]="value" [multiple]="multiple"
                [required]="required" [disabled]="disabled" [compareWith]="compareWith">
        <mat-option *ngFor="let opt of Mails" [value]="getOnlyId ? opt.Id : opt">{{opt.Title}}</mat-option>
    </mat-select>
</mat-form-field>
